export default __webpack_public_path__ + "static/media/maure_de_bretagne14.dac495cd.jpg";